import React from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

// styled-components 6 forwards every prop to the DOM unless told otherwise
const shouldForwardProp = (prop, target) =>
  typeof target !== 'string' || isPropValid(prop);

export const wrapRootElement = ({ element }) => (
  <StyleSheetManager shouldForwardProp={shouldForwardProp}>
    {element}
  </StyleSheetManager>
);

// The head snippet tracks the first load; this covers client-side navigations
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || !window._paq) return;
  setTimeout(() => {
    window._paq.push(['setReferrerUrl', prevLocation.href]);
    window._paq.push(['setCustomUrl', location.href]);
    window._paq.push(['setDocumentTitle', document.title]);
    window._paq.push(['trackPageView']);
  }, 100);
};
